<template>
    <div class="kv-site kv-main">
      <content class="kv-page">

        <section class="background-id_3m16 lahuni82" style=" position:relative;">
          <div class="position-relative kv-content">
            <div class="header-container no-cover">
              <div class="kv-fixed-header navigation-position menu-top" data-kv-scroll-offset="32">
                <div class="container-fluid navigation">
                  <header data-dynamic-container-element="true">
                    <div class="kv-background" style=" background-color: rgb(255,255,255);">
                      <div class="kv-background-inner"
                        data-image="background-image: url('images/menu.png');"
                        style="background-image: url('images/menu.png');background-color: rgb(255,255,255);opacity: 0.5;"
                      ></div>
                    </div>
                    <div class="logo" data-dynamic-navigation-element="logo"></div>
                    <MenuPrincipal />
                  </header>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- titulo -->
        <section id="subMenu" class="background-id_0 qobusy09 undefined" style=" position:relative;">
          <div class="container titles"><div class="row">
            <div class="section-text  offset-lg-2 col-12">
              <h2 data-type="text" class="section-title caption-title section-title--sm">
                Administração Judicial
                </h2>

                <Loader :show-loader="showLoader"/>

              </div>
            </div>
          </div>
        </section>

        <!-- submenu - áreas -->
        <section class="background-id_0 qobusy09 undefined" v-if="!showLoader">

              <div style="text-align:center" class="button-group" v-on:click="goToSubPage()">

                  <p data-type="text" class="section--sm section-subtitle section-subtitle--sm">
                    Clique em uma das áreas para consultar:
                  </p>

                    <router-link to="/administracao-judicial/recuperacao" class="button-sm button-ghost-primary">
                      RECUPERAÇÃO JUDICIAL
                    </router-link>

                    <router-link to="/administracao-judicial/falencia" class="button-sm button-ghost-primary">
                      FALÊNCIA
                    </router-link>

                    <router-link to="/administracao-judicial/outras-administracoes" class="button-sm button-ghost-primary">
                      OUTRAS ADMINISTRAÇÕES
                    </router-link>
          </div>

        </section>

        <!-- sub paginas -->
        <section class="background-id_0adjacent qobusy09" v-if="!showLoader">
          <div class="section section--sm">
            <div class="container">
                <router-view class="section-subtitle title--xs"></router-view>
            </div>
          </div>
        </section>

        <!-- contato -->
        <section class="background-id_0 qobusy09" v-if="!showLoader">
          <div class="position-relative">
            <div class="section section--sm align-center">
              <div class="container">
                <div class="row">
                  <div>
                    <p class="section-subtitle title--xs" data-type="text">
                      <font class="cstm-fnt"
                        style="font-size: 60.01%;">
                      Caso tenha algum questionamento adicional:</font>
                      <span
                        data-prop="subtitle"
                        class="ck-editable-element"
                        data-editable="basic"
                      ></span>
                    </p>
                    <div class="column button-group">
                      <router-link to="/contato" class="button-xs button-ghost-primary">
                        Entre em contato
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </content>
    </div>
</template>

<script>
import MenuPrincipal from "@/components/MenuPrincipal.vue";
import Footer from "@/components/Footer.vue";
import Loader from "@/components/Loader.vue";
import axios from "axios";
import { scrollToId } from '@/helpers/scroll.js'

export default {
  name: "AdministracaoJudicial",
  components: {
    MenuPrincipal,
    Footer,
    Loader
  },
  data() { 
    return { 
        apiUrl: process.env.VUE_APP_API_URL+'/empresas',
        showLoader: false
    }
  },
  mounted(){
    this.updateData();
  },
  methods:{
    goToSubPage:function(){
      scrollToId('subMenu')
    },
    updateData:function(){
      this.showLoader = true
      axios.get(this.apiUrl)
      .then(result => {
        this.$store.commit("atualizaEmpresas", result.data)
        this.$router.push('/administracao-judicial')        
        this.showLoader = false
      });
    }
  }
};
</script>